import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { all_routes } from '../../router/all-routes';

/**
 * Custom hook to monitor token expiration globally
 * DISABLED: Token refresh is handled automatically by axios interceptor
 * This hook is kept for backwards compatibility but does nothing
 * The axios interceptor handles token refresh when it receives 401 responses
 */
export const useTokenExpirationMonitor = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Only check if token exists at all, not if it's expired
    // The axios interceptor handles token refresh automatically
    const checkTokenExists = () => {
      const token = localStorage.getItem('token');
      
      // Only redirect if token is completely missing
      if (!token) {
        const currentPath = window.location.pathname;
        const isProtectedRoute = currentPath.startsWith('/dashboard');
        
        if (isProtectedRoute) {
          navigate(all_routes.login, { replace: true });
        }
      }
    };

    // Check once on mount
    checkTokenExists();

    // Watch for token removal from storage (logout events)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'token' && !e.newValue) {
        // Token was removed (logout)
        const currentPath = window.location.pathname;
        const isProtectedRoute = currentPath.startsWith('/dashboard');
        
        if (isProtectedRoute) {
          navigate(all_routes.login, { replace: true });
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [navigate]);
};
